import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { LogoWordmark, WaveDivider, SocialBadge } from './brand/Brand';
import SectionBg from './SectionBg';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Wrapper>
      <WaveDivider color="#4A2600" />
      <FooterContainer>
        <SectionBg tone="white" variant={0} />
        <Inner>
          <Top>
            <Brand>
              <LogoWordmark to="/" light />
              <Pitch>
                Des milliers de recettes gourmandes à la pâte à tartiner chocolat
                Tartina — trouve des idées selon ton budget et tente ta chance au
                jeu-concours.
              </Pitch>
              <SocialBadge />
            </Brand>

            <Col>
              <ColTitle>Explorer</ColTitle>
              <FLink to="/recipes">Toutes les recettes</FLink>
              <FLink to="/budget">Recherche par budget</FLink>
              <FLink to="/concours">Jeu-concours</FLink>
              <FLink to="/add-recipe">Ajouter une recette</FLink>
            </Col>

            <Col>
              <ColTitle>Catégories</ColTitle>
              <FLink to="/recipes?category=petit-déjeuner">Petit-déjeuner</FLink>
              <FLink to="/recipes?category=dessert">Desserts</FLink>
              <FLink to="/recipes?category=goûter">Goûters</FLink>
              <FLink to="/recipes?category=apéritif">Apéritifs</FLink>
            </Col>

            <Col>
              <ColTitle>La marque</ColTitle>
              <FA href="#">Notre histoire</FA>
              <FA href="#">Où acheter Tartina</FA>
              <FLink to="/contact">Nous contacter</FLink>
            </Col>
          </Top>

          <Bottom>
            <span>© {year} Tartina. Tous droits réservés.</span>
            <Legal>
              <FA href="#">Mentions légales</FA>
              <FA href="#">Confidentialité</FA>
            </Legal>
          </Bottom>
        </Inner>
      </FooterContainer>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  margin-top: 64px;
`;

const FooterContainer = styled.div`
  background: ${({ theme }) => theme.colors.chocolate};
  color: #fff;
  padding: 8px 0 32px;
  position: relative;
  isolation: isolate;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Top = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 40px;
  padding: 24px 0 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);

  @media (max-width: 880px) {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
`;

const Pitch = styled.p`
  margin: 0;
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.82);
  max-width: 36ch;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ColTitle = styled.h4`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 1.05rem;
  margin-bottom: 4px;
`;

const linkStyle = `
  color: rgba(255,255,255,0.85);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  &:hover { color: #FFDD00; }
`;

const FLink = styled(Link)`${linkStyle}`;
const FA = styled.a`${linkStyle}`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 20px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
`;

const Legal = styled.div`
  display: flex;
  gap: 18px;
`;

export default Footer;
